import React, { useEffect, useState } from 'react';
import api from '../../services/api';

/**
 * Exibe imagem servida pela API com autenticação (Bearer no axios).
 * @param {string} path Rota relativa, ex.: /api/v1/identity/enterprise-fotos/{id}/file
 */
export default function AuthenticatedBlobImage({ path, alt = '', className = '' }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let objectUrl;
    (async () => {
      try {
        const r = await api.get(path, { responseType: 'blob' });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(r.data);
        setSrc(objectUrl);
      } catch {
        if (!cancelled) setSrc(null);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (!src) {
    return (
      <div
        className={`animate-pulse rounded-md bg-gray-200 ${className}`}
        role="img"
        aria-label={alt || 'Carregando'}
      />
    );
  }
  return <img src={src} alt={alt} className={className} />;
}
